import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useTypedSelector } from 'common/hooks/store';
import { RootState } from 'app/store';

export function PocOutlet() {
  const { isPocModeActive } = useTypedSelector(
    (state: RootState) => state.pocToggle
  );
  const location = useLocation();

  return isPocModeActive ? (
    <Outlet />
  ) : (
    <Navigate to="/dashboard" state={{ from: location }} />
  );
}
